export default "__VITE_ASSET__jXM8bcam__"